import "./Background.scss";

import React from "react";
import { useRoute } from "../../../lib/hook/NavigationHooks";

export interface BackgroundOptions {
	fallback?: string;
	image?: string;
	overlay?: string;
	width?: number;
	height?: number;
	disabled?: boolean;
}

const Background = () => {
	const route = useRoute();

	const current = route?.options?.background;

	const fallback = (current && current.fallback) || "transparent";
	const fallbackBackground = ` linear-gradient(90deg, ${fallback} 20%, transparent 30%, transparent 50%, ${fallback} 80%)`;

	return current?.disabled !== true ? (
		<div
			className={"Background"}
			style={{ height: current && current.height, background: fallback }}
		>
			<div className={"Background__shape --skeletonIgnore"}>
				<div
					style={{
						background: current && current.image && `url(${current.image})`,
					}}
					className={"Background__image"}
				/>
				{current && current.overlay && (
					<div
						className={"Background__overlay"}
						style={{ background: current.overlay }}
					/>
				)}
			</div>
			<div
				className={"Background__fallback"}
				style={{
					color: current && current.fallback,
					background: fallbackBackground,
				}}
			/>
		</div>
	) : null;
};

export default React.memo(Background);
